import type { ReactNode } from 'react';
import styles from './EmptyState.module.css';

/**
 * An empty list, said kindly: a mark, why it is empty, and what to do next.
 * Request of 5 October 2026, section 8. It fades in rather than appearing, so
 * a list emptied by a filter does not blink.
 */
export function EmptyState({
  icon,
  heading,
  detail,
  action,
}: {
  icon: ReactNode;
  heading?: string;
  detail: string;
  /** The next step, such as Scan a case. */
  action?: ReactNode;
}) {
  return (
    <div className={styles.empty}>
      <span className={styles.icon} aria-hidden="true">
        {icon}
      </span>
      {heading !== undefined && <h3>{heading}</h3>}
      <p>{detail}</p>
      {action !== undefined && <div className={styles.action}>{action}</div>}
    </div>
  );
}
